import information from '@/views/mainContent/information'

import standardManage from '@/views/mainContent/information/standardManage'

import standardManageOrganization from '@/views/mainContent/information/standardManage/organization'

import legal from '@/views/mainContent/information/standardManage/organization/legal'
import system from '@/views/mainContent/information/standardManage/organization/system'
import system1 from '@/views/mainContent/information/standardManage/organization/system1'
import team from '@/views/mainContent/information/standardManage/organization/team'

import goods from '@/views/mainContent/information/standardManage/goods'

import goodsselect from '@/views/mainContent/information/standardManage/goods/goodsselect'
import goodslogin from '@/views/mainContent/information/standardManage/goods/goodslogin'
import goodsprotect from '@/views/mainContent/information/standardManage/goods/goodsprotect'
import goodsbg from '@/views/mainContent/information/standardManage/goods/goodsbg'

import open from '@/views/mainContent/information/standardManage/open'
import infomations from '@/views/mainContent/information/standardManage/open/infomations'
import visit from '@/views/mainContent/information/standardManage/open/visit'
import test from '@/views/mainContent/information/standardManage/open/test'


import safety from '@/views/mainContent/information/standardManage/safety'
import realize from '@/views/mainContent/information/standardManage/safety/realize'
import goodssafety from '@/views/mainContent/information/standardManage/safety/goods'
import publics from '@/views/mainContent/information/standardManage/safety/public'
import info from '@/views/mainContent/information/standardManage/safety/info'


import service from '@/views/mainContent/information/service'
import science from '@/views/mainContent/information/service/science'
import output from '@/views/mainContent/information/service/science/output'
import service1 from '@/views/mainContent/information/service/science/service'


import list from '@/views/mainContent/information/service/list'
import base from '@/views/mainContent/information/service/list/base'
import shorttime from '@/views/mainContent/information/service/list/shorttime'

import teac from '@/views/mainContent/information/service/teac'
import explain from '@/views/mainContent/information/service/teac/explain'
import exercise from '@/views/mainContent/information/service/teac/exercise'
import appraisal from '@/views/mainContent/information/service/teac/appraisal'


import culture from '@/views/mainContent/information/service/culture'
import communication from '@/views/mainContent/information/service/culture/communication'
import communicate from '@/views/mainContent/information/service/culture/communicate'
import numbers from '@/views/mainContent/information/service/culture/number'
import management from '@/views/mainContent/information/service/culture/management'

import society from '@/views/mainContent/information/society'
import audience from '@/views/mainContent/information/society/audience'
import structure from '@/views/mainContent/information/society/audience/structure'
import Satisfaction from '@/views/mainContent/information/society/audience/Satisfaction'

import influence from '@/views/mainContent/information/society/influence'
import follow from '@/views/mainContent/information/society/influence/follow'
import reward from '@/views/mainContent/information/society/influence/reward'
import participate from '@/views/mainContent/information/society/influence/participate'

import special from '@/views/mainContent/information/special'
import enclosure from '@/views/mainContent/information/enclosure'
import download from '@/views/mainContent/information/download'
import user from '@/views/mainContent/information/user'
import adduser from '@/views/mainContent/information/user/listNew/index'
import basemenu from '@/views/mainContent/information/base'
import otherfile from '@/views/mainContent/information/otherfile'
import performance from '@/views/mainContent/information/performance'
import fujian from '@/views/mainContent/information/fujian'

export default {
  path: '/informationDeclaration',
  component: information,
  exact: true,
  children: [
    {
      path: '/informationDeclaration/museumbaseinfo',
      component: basemenu,
      exact: true,
    },
    {
      path: '/standardManage',
      component: standardManage,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/standardManage/organization',
          component: standardManageOrganization,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/organization/legal',
              component: legal,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/system',
              component: system,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/system1',
              component: system1,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/team',
              component: team,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/goods',
          component: goods,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/goods/goodsselect',
              component: goodsselect,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodslogin',
              component: goodslogin,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsbg',
              component: goodsbg,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsprotect',
              component: goodsprotect,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/open',
          component: open,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/open/infomations',
              component: infomations,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/open/test',
              component: test,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/open/visit',
              component: visit,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/safety',
          component: safety,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/safety/realize',
              component: realize,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/goods',
              component: goodssafety,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/public',
              component: publics,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/info',
              component: info,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/service',
      component: service,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/service/science',
          component: science,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/science/output',
              component: output,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/science/service',
              component: service1,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/list',
          component: list,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/list/base',
              component: base,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/list/shorttime',
              component: shorttime,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/teac',
          component: teac,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/teac/explain',
              component: explain,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/teac/exercise',
              component: exercise,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/teac/appraisal',
              component: appraisal,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/culture',
          component: culture,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/culture/communication',
              component: communication,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/communicate',
              component: communicate,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/number',
              component: numbers,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/management',
              component: management,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/society',
      component: society,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/society/audience',
          component: audience,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/society/audience/structure',
              component: structure,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/audience/Satisfaction',
              component: Satisfaction,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/society/influence',
          component: influence,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/society/influence/follow',
              component: follow,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/influence/reward',
              component: reward,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/influence/participate',
              component: participate,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/addition/special',
      component: special,
      exact: true,
    },
    {
      path: '/informationDeclaration/enclosure',
      component: enclosure,
      exact: true,
    },
    {
      path: '/informationDeclaration/download',
      component: download,
      exact: true,
    },
    {
      path: '/user',
      component: user,
      exact: true,
    },
    { //用户管理
      path: '/informationDeclaration/adduser',
      component: adduser,
      exact: true,
    },
    { //附件管理
      path: '/informationDeclaration/attachfiles',
      component: fujian,
      exact: true,
    },
    { //附件管理
      path: '/informationDeclaration/attachfilesCentral',
      component: fujian,
      exact: true,
    },
    { //附件管理
      path: '/informationDeclaration/attachfilesScore',
      component: fujian,
      exact: true,
    },
    { //附件管理
      path: '/informationDeclaration/attachfilesProvince',
      component: fujian,
      exact: true,
    },
    {
      path: '/informationDeclaration/otherfile',
      component: otherfile,
      exact: true,
    },
    {
      path: '/informationDeclaration/otherfileCentral',
      component: otherfile,
      exact: true,
    },
    {
      path: '/informationDeclaration/otherfileScore',
      component: otherfile,
      exact: true,
    },
    {
      path: '/informationDeclaration/otherfileProvince',
      component: otherfile,
      exact: true,
    },
    { //其他文件
      path: '/informationDeclaration/jxdcb',
      component: performance,
      exact: true,
    },
  ]
}
